import {RouteParams} from 'types/routes'
import {UpdateRequestRoutes} from './updateRequests'

export const EmployeeRoutes: RouteParams[] = [...UpdateRequestRoutes]
